import axios from 'axios';
axios.defaults.baseURL = CRMHost; // Use same CRM host

export default {
    createCart: (userDetails) => {
        console.info("SHOPIFY_createCart");
        console.time("SHOPIFY_createCart");

        return axios.post('/api/v1/user/shopify/cart', {
            cognitoId: userDetails.cognitoId,
            email: userDetails.email
        }).then(result => result.data);
    }
}
